import { DatePicker, Form, Select } from 'antd'
import { FormInstance } from 'antd/es/form'
import { FC } from 'react'
import User from '../../../../components/form-items/user/user'
import {
    requiredDatePickerRules,
    requiredOneElementRules,
} from '../../../../constants/forms/validation/rules'
import { outputDateFormat } from '../../../../constants/constants'
import { BusinessRole } from '../../../../types/api/user'
import { ShiftScheduleFormValues } from './form-values'

interface ShiftScheduleFormProps {
    form: FormInstance<ShiftScheduleFormValues>
    shiftTypeOptions: { value: string; label: string }[]
    isLoading?: boolean
}

const ShiftScheduleForm: FC<ShiftScheduleFormProps> = ({
    form,
    shiftTypeOptions,
    isLoading,
}) => (
    <Form form={form} layout='vertical'>
        <Form.Item name='date' label='Дата' rules={requiredDatePickerRules}>
            <DatePicker disabled format={outputDateFormat} />
        </Form.Item>
        <User
            name='employee'
            label='Сотрудник'
            positions={[BusinessRole.SecondPrinter]}
            placeholder='Выберите сотрудника'
            rules={requiredOneElementRules}
        />
        <Form.Item name='shiftType' label='Тип смены' rules={requiredOneElementRules}>
            <Select options={shiftTypeOptions} placeholder='Выберите тип смены' loading={isLoading} />
        </Form.Item>
    </Form>
)

export default ShiftScheduleForm
